import logger from "@utils/logger";
const backendUrl = process.env.REACT_APP_BACKEND_BASE_URL;
export const verifyTokenAndFetchTemplate = async ({
  token,
  user_id,
  template_id,
  name,
  patient_id,
}) => {
  try {
    const res = await fetch(`${backendUrl}/emails/verify-template-link`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, user_id, template_id, name, patient_id }),
    });
    const data = await res.json();
    if (!res.ok) {
      const errorData = await res.json();
      throw new Error(errorData.details || "Verification failed");
    }

    logger.info(
      `Template verification successful for template ID: ${template_id}`
    );
    return data.data;
  } catch (error) {
    logger.error(`Error in verifyTokenAndFetchTemplate: ${error.message}`);
    throw error;
  }
};
export const savePatientFile = async (payload) => {
  try {
    const response = await fetch(`${backendUrl}/emails/save-patient-file`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    if (!response.ok) {
      logger.error(`Failed to insert file.`);
      throw new Error(data.details || "Unknown error occurred");
    }
    logger.info(`Successfully insert file with ID: ${data.file_id}`);
    return data;
  } catch (error) {
    logger.error(`Error in saveFile: ${error.message}`);
    throw error;
  }
};
